module.exports = __webpack_public_path__ + "static/media/Team-1.4441454b.jpg";